// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "7875" ? "angular-vendor" : chunkId) + "." + {"2515": "c1d340f8","5099": "153f4a3b","5154": "65188d38","7875": "a2caa970",}[chunkId] + ".js"
}